<script>
import BroadcastForm from "@/components/forms/BroadcastForm.vue";
import BroadcastGroupForm from "@/views/broadcast/BroadcastGroupForm.vue";

export default {
  name: "BroadcastGroups",
  components: {BroadcastGroupForm, BroadcastForm},
  data() {
    return {
      search: '',
      inLoading: false,
      broadcast_modal: false,
      update_broadcast_modal: false,
      delete_broadcast_modal: false,
      new_broadcast_group_modal: false,
      group: {},
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'members', value: 'members.length'},
        {text: 'Actions', value: 'actions'},
      ],
    }
  },

  methods: {

    sendBroadcastModal(group) {
      this.group = group
      this.broadcast_modal = true
    },

    deleteBroadcastModal(group) {
      this.group = group
      this.delete_broadcast_modal = true
    },

    updateBroadcastModal(group) {
      this.group = group
      this.update_broadcast_modal = true
    },

    async deleteBroadcastGroup(group) {
      this.inLoading = true
      await this.$store.dispatch('DELETE_BROADCAST', { id: group._id})
      this.group = {}
      this.inLoading = false
    },
  },

  computed: {
    broadcast_groups(v) {
      return this.$store.getters.broadcast_groups
    }
  },

  watch: {
    broadcast_groups(v) {
      return v
    }
  },

  created() {
    this.$store.dispatch('GET_BROADCAST_GROUPS')
  }
}
</script>

<template>
  <v-container>
    <v-toolbar flat height="40">
      <v-toolbar-title>Broadcast Groups</v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items>
        <v-btn class="ml-2" @click="new_broadcast_group_modal = true">New Broadcast Group</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="broadcast_groups"
        :search="search"
        :loading="$store.getters.isLoading1"
    >
      <template v-slot:top>
        <v-text-field
            v-model="search"
            label="Search User"
            style="width: 40%"
            class="mx-4"
        ></v-text-field>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <v-btn
              @click="sendBroadcastModal(item)"
              color="success"
              icon
              class="mt-3"
          >
            <v-icon>mdi-send</v-icon>
          </v-btn>
          <v-btn
              @click="updateBroadcastModal(item)"
              color="primary"
              icon
              class="mt-3"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
              @click="deleteBroadcastModal(item)"
              color="error"
              icon
              class="mt-3"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog v-model="broadcast_modal" width="500">
      <BroadcastForm
          :broadcast_group="group"
          @close="broadcast_modal = !broadcast_modal"
      />
    </v-dialog>

    <v-dialog v-model="new_broadcast_group_modal" width="50%">
      <BroadcastGroupForm
          @close="new_broadcast_group_modal = !new_broadcast_group_modal"
      />
    </v-dialog>

    <v-dialog v-model="update_broadcast_modal" width="50%">
      <BroadcastGroupForm
          :group-init="group"
          :editing="true"
          @close="update_broadcast_modal = !update_broadcast_modal"
      />
    </v-dialog>
    <v-dialog v-model="delete_broadcast_modal" width="50%">
      <v-card>
        <v-card-title>Delete Group</v-card-title>
        <v-card-text>Are you sure you want to delete this group? {{ group.title }}</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="delete_broadcast_modal = false">Cancel</v-btn>
          <v-btn class="error" :loading="inLoading" @click="deleteBroadcastGroup(group)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>

</style>